import styled from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';

const NavbarLeft = styled.div`
flexDirection: row;
display: flex;
margin: 0;
align-items: center;
`;

const ComponentTitleButton = styled(Button)`
  padding: 0 8px;
  margin-left: 10px;
  text-transform: none;
  font-size: 14px;
  justify-content: flex-start;
  letter-spacing: 0;
`;

export { NavbarLeft, ComponentTitleButton };
